import {t} from 'i18next'
import {Avatar} from 'primereact/avatar'
import React, {Fragment} from 'react'
import {Apprentice, Person} from '../../../../model/person.model'
import  {AvatarWithName} from '../../AvatarWithName'

export const AvatarCell = (person: Person | Apprentice | undefined): JSX.Element => {

	if (!person) {
		return <>
			<Avatar
				size={'normal'}
				shape="circle"
				className={'circle avatar'}
				icon={'fa-solid fa-question '}
			/>
			<span className={'unknown-name'}>{t<string>('core.unknown')}</span></>
	}
	return (
		<Fragment>
			<AvatarWithName person={person}/>
		</Fragment>
	)
}